import React, { useEffect, useContext, useState } from 'react';
import Highlight from 'react-highlight';
import { Card, CardBody, CardHeader, CardHeaderBtn } from './../../components/card/card.jsx';
import { AppSettings } from './../../config/app-settings.js';
import { useNavigate } from 'react-router-dom';

function LayoutFullWidth() {
	const context = useContext(AppSettings);
	const navigate = useNavigate();
	const [code1, setCode1] = useState();
	
	function handleBackBtn() {
		navigate(-1);
	}
	
	useEffect(() => {
		fetch('/quantum-react/assets/data/layout/full-width-code-1.json').then(function(response) { return response.text(); }).then((html) => { setCode1(html) });
		context.setAppSidebarNone(true);
		
		return function cleanUp() {
			context.setAppSidebarNone(false);
		}
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<div>
			<ul className="breadcrumb">
				<li className="breadcrumb-item"><a href="#/">LAYOUT</a></li>
				<li className="breadcrumb-item active">FULL WIDTH</li>
			</ul>
			
			<h1 className="page-header">
				Full Width <small>page header description goes here...</small>
			</h1>
			
			<Card className="mb-3">
				<CardHeader className="with-btn">
					INSTALLATION
					<CardHeaderBtn />
				</CardHeader>
				<CardBody>
					<p>
					Add the following code for full width page setting.
					</p>
				</CardBody>
				<div className="hljs-container">
					<Highlight className='javascript'>{code1}</Highlight>
				</div>
			</Card>
			
			<p>
				<a href="#/" onClick={handleBackBtn} className="btn btn-default"><i className="fa fa-chevron-left fa-fw ms-n1"></i> Back to previous Page</a>
			</p>
		</div>
	)
}

export default LayoutFullWidth;